export enum OrganizationType {
  VC = 'VC',
  PE = 'PE',
  FAMILY = 'FAMILY_OFFICE',
  OTHER = 'OTHER',
}

const organizationTypes = [
  [OrganizationType.VC, 'VC'],
  [OrganizationType.PE, 'PE'],
  [OrganizationType.FAMILY, 'Family office'],
  [OrganizationType.OTHER, 'Other'],
] as const;

export const organizationTypesMap: Map<OrganizationType, string> = new Map(organizationTypes);
export const reversedOrganizationTypesMap: Map<string, OrganizationType> = new Map(organizationTypes.map(([k, v]) => [v, k]));

